import React from "react";
import "./Bola.css";
export default function Bola() {
  return <div className="bola"></div>;
}
